export const USERTYPE = {
  TEAM_MEMBER: "Team Member",
  CLIENT: "Client",
  clients: "Client",
  "team-members": "Team Member",
  OWNER: "Owner",
};
